import React from 'react'
import unlocklogo from 'assets/images/Unlock.gif'

const UnlockingLoader = (props) => {
    return (
        <div className='page-loader-container m-auto'>
            <div className='d-flex'>
                <div className='mx-auto'>
                    <img className='unlock-logo mx-auto' src={unlocklogo} alt='img' />
                </div>
            </div>
            <div className='page-loader-text mt-1'>
                <span>{`Unlocking ${props.data}`}</span>
            </div>
        </div>
    )
}

export default UnlockingLoader